import { ApolloError, useQuery } from '@apollo/client';

import { GetAdAccountIdsByCampaignsQuery, GetAdAccountIdsByCampaignsQueryVariables } from '../../../types';
import { GET_AD_ACCOUNT_IDS_BY_CAMPAIGNS } from './getAdAccountIdsByCampaigns';

type GetSearchUsers = {
  data: GetAdAccountIdsByCampaignsQuery['getAdAccountIdsByCampaigns'];
  loading: boolean;
  error?: ApolloError;
};

const useGetAdAccountIdsByCampaigns = (campaignIds: string[]): GetSearchUsers => {
  const { data, loading, error } = useQuery<GetAdAccountIdsByCampaignsQuery, GetAdAccountIdsByCampaignsQueryVariables>(
    GET_AD_ACCOUNT_IDS_BY_CAMPAIGNS,
    {
      variables: {
        campaignIds,
      },
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    data: data?.getAdAccountIdsByCampaigns || [],
    loading,
    error,
  };
};

export default useGetAdAccountIdsByCampaigns;
